/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum InstitutionType {
  INSURANCE_AGENCY = 'INSURANCE_AGENCY',

  COLLECTING_CENTRE = 'COLLECTING_CENTRE',

  CREDIT_COMPANY = 'CREDIT_COMPANY',

  BANK = 'BANK',

  DEALER = 'DEALER',

  STOREDEALOR = 'STOREDEALOR',

  IMPORTER = 'IMPORTER',

  MANUFACTURER = 'MANUFACTURER',

  COMPANY = 'COMPANY',

  BRANCH = 'BRANCH',
}
